import React from "react";
import * as Yup from 'yup';
import { ImpiantoData, ClienteDto, ApparecchioCategory, ImpiantoClimaDto } from "../../generated"
import { FrazioneSelector } from "../../comuni/components/FrazioneSelector";
import { ComuniAutocomplete } from "../../comuni/components/comuniAutocomplete";
import { Forms, Divider } from "../../common/components/CmForms";
import { ContrattiAccordion } from "../../contratti/components/ContrattoAccordion";
import { CheckBox } from "../../common/components/checkBox2";
import { CustomerData } from "../../customers/components/CustomerData";
import ModelloClimaData from "../../modelliClima/components/ModelloClimaData";
import { FormTextInput } from "../../common/components/textInput";
import { ComuneData } from "../../comuni/components/ComuneData";
import { TechnicianSelector } from "../../technicians/components/TechnicianSelector";
import customersStore from "../../customers/customersStore";
import { withApparecchioCateogories } from "../../impianti/withApparecchioCategories";
import { Dictionary } from "../../common/AbstractStores";
import RefrigeranteSelector from "./RefrigeranteSelector";
import { SorgenteClimaTypeSelector } from "./SorgenteClimaSelector";
import TipoFGasSelector from "./TipoFGasSelector"
import TipoSplitSelector from "./TipoSplitSelector";
import { SmartModelloClimaSelector } from "../../modelliClima/components/SmartModelloClimaSelector";
const { Form, FormText, FormInteger, FormDate, ActionBar, FormTextArea, isEqual, FormFloat } = Forms<ImpiantoClimaFormData>()

export class ImpiantoClimaFormData extends ImpiantoClimaDto {
    createInterventi?: boolean;
}

interface Props {
    impianto: ImpiantoClimaFormData;
    onSubmit: (impianto: ImpiantoClimaDto) => void;
    onCancel: () => void;
    cliente: ClienteDto;
    apparecchioCategories: Dictionary<ApparecchioCategory>
}

export const ToImpiantoData = (impianto: ImpiantoClimaDto) => ImpiantoClimaDto.fromJS({
    ...impianto,
    idApparecchio: impianto.idApparecchio,
    codFisComune: impianto.codFisComune,
    codFrazione: impianto.codFrazione,
    idCliente: impianto.idCliente,
});


const isImpiantoEqual = (i1: ImpiantoClimaDto, i2: ImpiantoClimaDto) => isEqual(ToImpiantoData(i1), ToImpiantoData(i2));

class ImpiantoClimaForm extends React.Component<Props> {

    private static validationSchema = Yup.object<Partial<ImpiantoClimaDto>>({
        idApparecchio: Yup
            .number()
            .test("caldaia-required", "Campo obbligatorio", value => value != null && value > 0),
    })

    render() {
        const { impianto, cliente } = this.props;
        return (
            <Form
                onSubmit={this.props.onSubmit}
                initialValues={impianto}
                validationSchema={ImpiantoClimaForm.validationSchema}
                isEqual={isImpiantoEqual}
            >
                {
                    ({ values, set, errors }) => {
                        const title = values.idApparecchio > 0
                            ? <span><ModelloClimaData id={values.idApparecchio} template={x => x.marca ?? ""} /> di <CustomerData id={values.idCliente} template={x => x.cognomeProprietario ?? ""} /></span>
                            : "Nuovo impianto";
                        return <>
                            <div className="card">
                                <div className="card-header bg-theme ">
                                    <h3 className="text-white text-uppercase mb-0">
                                        {title}
                                    </h3>
                                </div>
                                <div className="card-body pb-4">
                                    <Divider caption="Dati apparecchio" />
                                    <div className="row align-items-center">
                                        <div className="col-12 col-md-6">
                                            <SmartModelloClimaSelector
                                                error={errors.idApparecchio}
                                                onChange={value => set("idApparecchio", value?.id ?? 0)}
                                                value={values.idApparecchio}
                                            />
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <div className="row">
                                                <div className="col-12 col-sm-6">
                                                    <FormDate
                                                        label="Data Installazione"
                                                        name="dataInstallazione"
                                                    />
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <FormInteger
                                                        name="annoFabbricazione"
                                                        label="Anno fabbricazione"
                                                    />
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <FormText
                                                        name="matricola"
                                                        label="Matricola"
                                                    />
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <FormText
                                                        name="codiceImpiantoCatasto"
                                                        label="Codice"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Divider caption="Dati installazione" />
                                    <div className="row">
                                        <div className="col-12 col-sm-6">
                                            <RefrigeranteSelector
                                                label="Tipo refrigerante"
                                                value={values.refrigeranteType ?? null}
                                                onChange={async refrigerante => await set("refrigeranteType", refrigerante?.id)}
                                            />
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <FormFloat
                                                name="capacitaCircuitoRefrigerante"
                                                label="Capacità circuito refrigerante (Kg)"
                                            />
                                        </div>

                                        <div className="col-12 col-sm-6">
                                            <SorgenteClimaTypeSelector
                                                label="Sorgente Lato Esterno"
                                                value={values.sorgenteEsterna ?? null}
                                                onChange={async v => await set("sorgenteEsterna", v ?? undefined)}
                                            />
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <SorgenteClimaTypeSelector
                                                label="Sorgente Lato Utenze"
                                                value={values.sorgenteUtenze ?? null}
                                                onChange={async v => await set("sorgenteUtenze", v ?? undefined)}
                                            />

                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 col-md-3">
                                            <FormFloat
                                                name="potenzaFrigoNominale"
                                                label="Pot. Frigorifera Nom. (kW)"
                                            />
                                        </div>
                                        <div className="col-12 col-md-3">
                                            <FormFloat
                                                name="potenzaTermicaNominale"
                                                label="Pot. Termica Nominale (kW)"
                                            />
                                        </div>
                                        <div className="col-12 col-md-3">
                                            <FormFloat
                                                name="potAssorbitaRaffreddamento"
                                                label="P. Elett. Assorbita in Raff. (kW)"
                                            />
                                        </div>
                                        <div className="col-12 col-md-3">
                                            <FormFloat
                                                name="potAssorbitaRiscaldamento"
                                                label="P. Elett. Assorbita in Risc. (kW)"
                                            />
                                        </div>
                                        <div className="col-12 col-md-3">
                                            <FormText
                                                name="cop"
                                                label="COP"
                                            />
                                        </div>
                                        <div className="col-12 col-md-3">
                                            <FormText
                                                name="eer"
                                                label="Eer"
                                            />
                                        </div>
                                        <div className="col-12 col-md-3">
                                            <TipoFGasSelector
                                                label="Tipo Apparecchiatura FGAS"
                                                value={values.tipoFGas ?? null}
                                                onChange={async v => await set("tipoFGas", v ?? undefined)}
                                            />
                                        </div>
                                        <div className="col-12 col-md-3">
                                            <FormText
                                                name="codiceFgas"
                                                label="Codice Univoco FGAS"
                                            />
                                        </div>
                                        <div className="col-12 col-md-3">
                                            <TipoSplitSelector
                                                label="Tipologia"
                                                value={values.tipoSplit ?? null}
                                                onChange={async v => await set("tipoSplit", v ?? undefined)}
                                            />
                                        </div>
                                        <div className="col-12 col-md-3">
                                            <TechnicianSelector
                                                label="Installatore"
                                                onChange={technician => set("technicianId", technician?.id)}
                                                value={values.technicianId || null}
                                                error={errors.technicianId}
                                            />
                                        </div>
                                    </div>
                                    <Divider caption="Locazione Impianto" />
                                    <CheckBox
                                        checked={!values.inheritsAddress}
                                        label="Indirizzo diverso da quello del cliente"
                                        onChange={checked => set("inheritsAddress", !checked)}
                                    />
                                    <div className="row">
                                        <div className="col-12 col-md-6">
                                            <ComuniAutocomplete
                                                onChange={async comune => {
                                                    await set("codFisComune", comune?.codFisComune ?? undefined);
                                                    comune?.cap && await set("cap", comune?.cap ?? undefined);
                                                }}
                                                value={values.inheritsAddress ? cliente.comune?.codFisComune : values.codFisComune}
                                                label="Comune"
                                                error={errors.codFisComune}
                                                readOnly={values.inheritsAddress}
                                            />
                                        </div>
                                        <div className="col-12 col-md-2">
                                            <ComuneData
                                                codFisComune={values.inheritsAddress ? (cliente.comune?.codFisComune ?? "") : (values.codFisComune ?? "")}
                                                selector={comune => <FormTextInput<ImpiantoData>
                                                    label="Cap"
                                                    name="cap"
                                                    value={values.inheritsAddress ? (cliente.cap ?? cliente.comune?.cap) : (values.cap ?? comune?.cap)}
                                                    onChange={e => set("cap", e.target.value)}
                                                    readOnly={values.inheritsAddress}
                                                />
                                                }
                                            />
                                        </div>
                                        <div className="col-12 col-md-4">
                                            <FormTextInput
                                                value={values.inheritsAddress ? cliente.indirizzo : values.indirizzo}
                                                onChange={e => set("indirizzo", e.target.value)}
                                                label="Indirizzo"
                                                readOnly={values.inheritsAddress}
                                            />
                                        </div>
                                        <div className="col-12 col-md-6">
                                            {(values.inheritsAddress ? cliente.comune?.codFisComune : values.codFisComune) && <FrazioneSelector
                                                codFisComune={values.inheritsAddress ? (cliente.comune?.codFisComune ?? "") : (values.codFisComune ?? "")}
                                                onChange={frazione => set("codFrazione", frazione?.codFrazione ?? undefined)}
                                                value={values.inheritsAddress ? (cliente.frazione?.codFrazione ?? null) : (values.codFrazione ?? null)}
                                                label="Frazione"
                                                error={errors.codFrazione}
                                                readonly={values.inheritsAddress}
                                            />}
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <FormTextInput
                                                label="Piano"
                                                onChange={piano => set("piano", piano.target.value)}
                                                value={values.inheritsAddress ? cliente.piano : values.piano}
                                                readOnly={values.inheritsAddress}
                                            />
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <FormTextArea
                                                name="noteImpianto"
                                                label="Nota Impianto"
                                                rows={4}
                                            />
                                        </div>
                                    </div>
                                    <ContrattiAccordion idImpianto={impianto.id} />
                                    <ActionBar onCancel={this.props.onCancel} />
                                </div>
                            </div>
                        </>
                    }
                }
            </Form >
        );
    }
}


const attached = (props: Omit<Props, "cliente">) => {
    const cliente = customersStore.use(props.impianto.idCliente);
    if (cliente == null)
        return null;
    return <ImpiantoClimaForm {...props} cliente={cliente} />
}

export default withApparecchioCateogories(attached)(x => x.allByKey(), "apparecchioCategories")